import s from "./SectionFilters.module.scss";
import { Container } from "components/layout/Container";
import { EssayFiltersView } from "components/shared/EssayFiltersView";

import { SamplesFilterMobileForm } from "@/components/forms/SamplesFilterMobileForm";
import { SamplesFilterDesktopForm } from "@/components/forms/SamplesFilterDesktopForm";
import { useSampleFilterContext } from "@/components/SampleFilterContext";

type SectionFiltersProps = {
  showTotal?: true;
};

export const SectionFilters = ({ showTotal }: SectionFiltersProps) => {
  const context = useSampleFilterContext();
  if (!context) return null;
  const { filterProps, currentItems, count, page, currentTotal, selectedValues, onValueChange } = context;

  return (
    <section id="section-sample-filters" className={s.sectionFilters}>
      <Container className={s.container}>
        {showTotal && (
          <p className={s.total}>
            Search results: <span>{currentTotal}</span>
          </p>
        )}
        <SamplesFilterMobileForm
          filterParams={filterProps.filterParams}
          selectedValues={selectedValues}
          onChange={onValueChange}
          resultsCount={currentTotal}
        />
        <div className={s.inner}>
          <div className={s.left}>
            <EssayFiltersView {...filterProps} items={currentItems} pagesCount={count} currentPage={page} />
          </div>

          <div className={s.aside}>
            <SamplesFilterDesktopForm
              filterParams={filterProps.filterParams}
              selectedValues={selectedValues}
              onChange={onValueChange}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};
